var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _g2, _path10, _g3, _path11, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 56,
    viewBox: "0 0 142 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 141,
    height: 55,
    rx: 19.5,
    fill: "url(#paint0_linear_2361_2154)",
    fillOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 141,
    height: 55,
    rx: 19.5,
    stroke: "#8CBEE4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 130,
    height: 44,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.094 33.2201C67.6078 33.4489 66.6641 33.7348 65.2342 33.7348C61.2878 33.7348 59 31.0181 59 27.5292C59 23.4398 61.8883 21.2378 65.4916 21.2378C66.8929 21.2378 67.6364 21.4952 68.094 21.7525L67.665 24.2119C67.1216 23.9831 66.5783 23.7544 65.606 23.7544C63.8901 23.7544 62.0885 24.7839 62.0885 27.472C62.0885 29.9028 63.547 31.1897 65.6346 31.1897C66.4639 31.1897 67.0359 31.0467 67.665 30.7321L68.094 33.2201Z",
    fill: "#0073BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5633 29.8446C81.6777 30.9885 82.5928 31.5891 84.0513 31.5891C84.9378 31.5891 85.9387 31.3317 86.625 30.9313L87.0254 33.0189C85.9959 33.5337 84.852 33.7339 83.6509 33.7339C80.448 33.7339 78.7607 31.8178 78.7607 28.8723C78.7607 26.0412 80.591 24.2109 83.3649 24.2109C86.1961 24.2109 87.4829 26.2985 87.4829 28.9295C87.4829 29.2155 87.4543 29.6444 87.4257 29.8446H81.5633ZM84.7662 27.9572C84.7662 27.2995 84.4516 26.1556 83.1933 26.1556C82.1066 26.1556 81.5919 27.0993 81.5061 27.9572H84.7662Z",
    fill: "#0073BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6003 33.3915L87.6262 24.5835H90.6003L92.2018 30.8177H92.259L93.8604 24.5835H96.806L93.8604 33.3915H90.6003Z",
    fill: "#0073BD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5775 27.4713C97.5775 26.1844 97.5489 25.3265 97.4917 24.583H100.008L100.094 26.213H100.151C100.58 24.9262 101.438 24.44 102.325 24.3828C102.754 24.3542 102.954 24.3828 103.211 24.44V27.0138C102.954 26.9566 102.468 26.8994 102.124 26.928C101.095 27.0138 100.466 27.7573 100.294 28.6438C100.266 28.8154 100.237 29.0156 100.237 29.2444V33.3624H97.5775V27.4713Z",
    fill: "#0073BD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.62 28.9867C112.62 31.875 110.876 33.7625 108.073 33.7625C105.271 33.7625 103.526 31.875 103.526 28.9867C103.526 26.0984 105.271 24.2109 108.073 24.2109C110.876 24.2109 112.62 26.0984 112.62 28.9867ZM109.846 28.9867C109.846 27.5568 109.36 26.2985 108.073 26.2985C106.786 26.2985 106.3 27.5282 106.3 28.9867C106.3 30.4166 106.786 31.6748 108.073 31.6748C109.36 31.6462 109.846 30.4166 109.846 28.9867Z",
    fill: "#0073BD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.821 27.3854C113.821 26.2987 113.793 25.355 113.735 24.5828H116.252L116.309 25.8125H116.366C116.709 25.2406 117.653 24.2969 119.083 24.2969C120.856 24.2969 122 25.498 122 28.1003V33.3908H119.312V28.5007C119.312 27.3854 118.911 26.6133 117.968 26.6133C117.224 26.6133 116.767 27.128 116.595 27.6428C116.538 27.8143 116.509 28.0717 116.509 28.3291V33.3908H113.821V27.3854Z",
    fill: "#0073BD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6712 24.2974C73.6131 24.2974 72.5836 24.7836 72.0402 25.5557H72.0116V21.2661L69.3235 22.1812V33.3342H72.0116V28.1581C72.0116 27.4145 72.4978 26.5852 73.4415 26.5852C74.4424 26.5852 74.8428 27.3859 74.8428 28.5298V33.3628H77.5309V28.1581C77.5023 25.5271 76.3584 24.2974 74.6712 24.2974Z",
    fill: "#0073BD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2361_2154",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 11,
    width: 19,
    height: 13
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23.3919L36.5795 17.2044L18 11V23.3919Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2361_2154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4073 2.15869L42.4796 15.2945L30.1552 32.2341L12.0999 19.1152L24.4073 2.15869Z",
    fill: "url(#paint1_linear_2361_2154)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2361_2154",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 11,
    width: 38,
    height: 19
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5795 17.2044L18 23.3919L36.5795 29.5964L55.1758 23.3919V11L36.5795 17.2044Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2361_2154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5396 27.821L21.5503 0.0786133L60.6365 12.7749L51.6257 40.5173L12.5396 27.821Z",
    fill: "url(#paint2_linear_2361_2154)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2361_2154",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 25,
    width: 19,
    height: 13
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18 25.4038V37.7958L36.5795 31.6082L18 25.4038Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2361_2154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4073 16.562L42.4796 29.6809L30.1552 46.6374L12.0999 33.5185L24.4073 16.562Z",
    fill: "url(#paint3_linear_2361_2154)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2361_2154",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 25,
    width: 38,
    height: 19
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5795 31.5913L18 37.7958L36.5795 44.0002L55.1758 37.7958V25.4038L36.5795 31.5913Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2361_2154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5396 42.2253L21.5503 14.4829L60.6365 27.1792L51.6257 54.9216L12.5396 42.2253Z",
    fill: "url(#paint4_linear_2361_2154)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2361_2154",
    x1: 73.4244,
    y1: 56,
    x2: 73.335,
    y2: -0.00372781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0060B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0060B7",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2361_2154",
    x1: 18.2571,
    y1: 10.6397,
    x2: 33.3742,
    y2: 21.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00999451,
    stopColor: "#00A9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00A8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0081C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0062B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2361_2154",
    x1: 33.8588,
    y1: 28.6861,
    x2: 41.097,
    y2: 6.40933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303951,
    stopColor: "#0075C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0909705,
    stopColor: "#008ED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1544,
    stopColor: "#00A0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2218,
    stopColor: "#00ABEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5929,
    stopColor: "#00A7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7239,
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8767,
    stopColor: "#0077C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#0066B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2361_2154",
    x1: 18.2561,
    y1: 25.0411,
    x2: 33.3736,
    y2: 36.0246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E11837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CF3141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#B33848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B2E3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2361_2154",
    x1: 33.8513,
    y1: 43.1098,
    x2: 41.0907,
    y2: 20.8294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B2E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0504669,
    stopColor: "#AC2A3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1509,
    stopColor: "#C8233B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2515,
    stopColor: "#DD1E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3514,
    stopColor: "#E91B3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ED1A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6911,
    stopColor: "#C4243B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9B2E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B2E3C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.e0fc11d4430102d47fca476367e2c21e.svg";
export { ForwardRef as ReactComponent };